require('./draganddrop');
module.exports = 'ang-drag-drop';
